import React from 'react';
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import faker from 'faker';

const LineGraph = () => {

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
      );

    const options = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top'
          },
          title: {
            display: false,
            text: 'Chart.js Line Chart',
          },
        },
      };
      const labels = ['01', '02', '03', '04', '05', '06', '07'];


      const caredata = {
        labels: ["Jan", "Feb", "Mar", "April", "May", "June"],
        datasets: [
          {
            label: "Active",
            data: [0, 200, 20, 350, 150, 400],
            fill: true,
            backgroundColor: "rgba(59,122,254,0.2)",
            borderColor: "rgba(59,122,254,1)",

          },
          {
            label: "In Active",
            data: [100, 180, 80, 300, 20, 350],
            fill: true,
            borderColor: "rgba(137,156,168,1)",

          }
        ]
      };
  
  return (
    <Line options={options} data={caredata} />
    )
}

export default LineGraph